import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, tap } from 'rxjs';

import { PageSearchResult } from '../models';
import { SearchState, D4CActions, Selectors } from '../store';
import { CaSubscriber } from '@ca/ca-utils';
import { HighlightPipe } from '../pipes/highlight.pipe';
import { MetaComponent } from '../components/meta.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { LanguagePrefixPipe } from "@ca/ca-ng-core";

@Component({
  selector: 'd4c-search',
  imports: [CommonModule, FormsModule, HighlightPipe, MetaComponent, RouterModule, LanguagePrefixPipe],
  template: `
    @if (data$ |async; as data) {
      @if (data.page.meta) {
        <d4c-meta [metaTags]="data.page.meta"></d4c-meta>
      }
    <div id="search-page">
      <section class="search-input">
        <input
          autofocus
          type="text"
          onfocus="this.value=''"
          [placeholder]="data.form.button_search"
          [(ngModel)]="searchInput"
          (keyup.enter)="search()" />
        <button class="cta-btn" (click)="search()"><span class="material-symbols-outlined">search</span>{{data.form.button_search}}</button>
      </section>

      <section class="search-output">
        <div class="output-header">
          <p class="result">{{data.form.showing_results_for}}: {{ searchInput$ | async }}</p>
        </div>
        <div class="search-results">

          @for (page of searchResults$ | async; track page) {
            <a [routerLink]="page.routerLink |languagePrefix | async">
            <div class="search-result">
              <h2 [innerHTML]="page.title | highlight: submittedSearch"></h2>
              <p [innerHTML]="page.richText| highlight: submittedSearch"></p>
              <span class="info-block-cta material-symbols-outlined"> more_vert </span>
            </div>
            </a>
          }

          @if (noResultsMessage$ | async; as msg) {
            <div class="search-result">
              <h2 class="error">{{ msg }}</h2>
            </div>
          }
          </div>
        </section>
      </div>
    }
  `,
})
export class SearchComponent implements OnInit, OnDestroy {
  private sub = new CaSubscriber();
  private store = inject(Store<{ search: SearchState }>);
  private route = inject(ActivatedRoute);

  protected data$ = this.store.select(Selectors.selectSearchPage);
  protected searchResults$: Observable<PageSearchResult[] | undefined> = this.store.select(Selectors.selectSearchResults);
  protected searchInput$: Observable<string> = this.store.select(Selectors.selectSearchInput);

  protected noResultsMessage$ = this.store.select(Selectors.selectNoResultsMessage);
  searchInput: string = '';
  submittedSearch: string = '';

  private queryObserver = ({ query }: { query?: string }) => {
    this.store.dispatch(D4CActions.LoadSearchPage({ query }))
  };
  private searchObserver = (input: string) => {
    this.searchInput = input;
    this.submittedSearch = input;
  }

  ngOnInit(): void {
    this.sub.subscribe(this.route.queryParams, this.queryObserver)
    this.sub.subscribe(this.searchInput$, this.searchObserver);
  }

  ngOnDestroy(): void {
    this.sub.closeSubscriptions();
  }

  search() {
    this.store.dispatch(D4CActions.SubmitSearch({ query: this.searchInput }));
  }
}
